import React,{ Component } from 'react';

import {
  Row,
  Col,
  Button,
  FormText
} from 'reactstrap';

import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import TextInput from '../../../shared/components/TextInput';
import HiddenInput from '../../../shared/components/HiddenInput';
import Form from '../../../shared/components/Form';
import TutorialPopover from '../../../shared/components/TutorialPopover';
import DCMTagInput from '../../../shared/components/DCMTagInput';

import { validatePuzzleEngagement } from '../../../shared/validators';

class CampaignPuzzleForm extends Component {
  constructor(){
    super();

    this.state = {
      validationMessages:{},
      isAddingChoice:false,
      image:null,
      isShowingPopover:false
    };
  }

  componentDidMount(){
    if(this.props.activeEngagementImageURL && this.props.activeEngagementImageFileName){
      this.setState({image:{
          id:this.props.activeEngagementImageId,
          fileName:this.props.activeEngagementImageFileName,
          large:this.props.activeEngagementImageURL
        }});
    }
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.open && nextProps.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }

    if(this.props.open && !nextProps.open){
      this.setState({isShowingPopover:false});
    }
  }

  handleSubmit(data){
    const image = this.state.image;

    data.tags = (data.firstTags || []);

    if(image){
      data.firstImageURL = image.large;
      data.firstImageFileName = image.fileName;
      data.firstImageId = image.id;
    }

    const validationMessages = validatePuzzleEngagement(data);

    delete data.firstTags;
    delete data.secondTags;

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
      this.props.onSubmit(data);
    } else {
      this.setState({validationMessages:{}});
      this.props.onSubmit(data);
    }
  }

  render(){
    return (
      <Form
        includeEmpty
        onSubmit={(data) => this.handleSubmit(data)}
      >
        <TutorialPopover
          open={this.state.isShowingPopover && this.props.isShowingTutorial}
          target={`PuzzleTextInput_${this.props.activeEngagementId}`}
          onCloseClick={() => this.setState({isShowingPopover:false})}
          title='Puzzle engagement'
        >
          <p>
            Users take a scrambled version of your image and slide the pieces into place to reveal the final version
            <br /><br />
            Examples:<br />
            Consumers have fun engaging with your brand<br />
            Increase brand awareness<br />
            Improve brand or product recall
          </p>
        </TutorialPopover>
        <HiddenInput name='id' value={this.props.activeEngagementId} />
        <TextInput
          id={`PuzzleTextInput_${this.props.activeEngagementId}`}
          label='Title'
          name='text'
          defaultValue={this.props.activeEngagementText}
          placeholder='Enter your puzzle name here'
          warning={this.state.validationMessages['text']}
          maxLength={30}
          showLengthIndicatorAtLength={15}
        />
        <br />
        <DroppableFileInput
          id={`PuzzleFileInput_${this.props.activeEngagementId}`}
          label='Image'
          text='Upload image'
          name='firstImage'
          fileType='image'
          cropperAspectRatio={9/16}
          onChange={(image) => this.setState({image:image})}
          warning={this.state.validationMessages['firstImageURL']}
          existingFileName={this.props.activeEngagementImageFileName}
          existingFileURL={this.props.activeEngagementImageURL}
          tooltip={(
            <span>Use a large crisp 9x16 image.<br />We recommend 450px by 800px.  <br />Maximum file size of 2MB.</span>
          )}
        />
        <DCMTagInput
          type='first'
          name='firstTags'
          defaultValue={this.props.activeEngagementFirstTags}
          warning={this.state.validationMessages['firstTags']}
        />
        <br />
        <Button size='sm' color='primary' type='submit'>
          &nbsp;&nbsp;Save&nbsp;&nbsp;
        </Button>
      </Form>
    )
  }
}
CampaignPuzzleForm.defaultProps = {
  onDeleteChoiceClick:() => {},
  onAddChoiceClick:() => {},
  isShowingTutorial:true,
  showSuperadminFeatures:false
};

export default CampaignPuzzleForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignPuzzleForm.js